module.exports = __webpack_public_path__ + "img/head-bar-bg.d2b10fde.jpg";